import '@fontsource/google-sans/latin-500.css'

import * as React from 'react'

import { cn } from '../../utils/cn'
import googleLogo from '../icons/google-g.png'

/**
 * Google's "Continue with Google" button (light theme). Google's branding guidelines fix its fill,
 * border, text color, font and spacing and the unmodified G, so it keeps them instead of our tokens.
 */
function GoogleSignInButton({ className, ...props }: Omit<React.ComponentProps<'button'>, 'children'>) {
  return (
    <button
      type="button"
      data-slot="google-sign-in-button"
      className={cn(
        "focus-visible:ring-ring/50 inline-flex h-10 shrink-0 items-center justify-center gap-2.5 rounded-[4px] border border-[#747775] bg-white px-3 font-[family-name:'Google_Sans',sans-serif] text-[14px] leading-5 font-medium whitespace-nowrap text-[#1F1F1F] transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50",
        className
      )}
      {...props}
    >
      {/* Google's own G, cropped from its sign-in assets; the label names the button. */}
      <img src={googleLogo} alt="" className="size-5" />
      Continue with Google
    </button>
  )
}

export { GoogleSignInButton }
